import { Status, Subscription, SubscriptionKind } from "@blacknut/javascript-sdk/dist";
import { StorageKey } from "core/services";

export const isTryBuy = (sub: Subscription | undefined) =>
  isBlkTryBuy(sub) || isLGTryBuy(sub);

export const isBlkTryBuy = (sub: Subscription | undefined) =>
  sub?.plan.publicId === "trial_blk" && sub.status === Status.TRIALING;

export const isLGTryBuy = (sub: Subscription | undefined) =>
  sub?.plan.publicId === "test_trial" &&
  sub.status === Status.TRIALING &&
  (sub.kind === SubscriptionKind.LG ||
    !!localStorage.getItem(StorageKey.FEAT_WEBOS10YRS));
